<template>
  <div>
    <!-- 搜索/新增 -->
    <div class="list-hd">
      <el-form :inline="true" v-model="searchValue" class="demo-form-inline">
        <el-form-item label="设备号：">
          <el-input v-model="searchValue.gdid"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" plain @click="searchUsersList"
            >查询</el-button
          >
          <el-button type="success" plain @click="dialogFormVisible = true"
            >添加</el-button
          >
        </el-form-item>
        <el-form-item>
          <el-button type="success" @click="onExport()"
            >导出</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <el-dialog title="添加黑名单" :visible.sync="dialogFormVisible">
      <el-form>
        <el-form-item label="黑名单（多个设备号请用英文逗号,分割开）">
          <el-input v-model="addBlackList" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="备注:">
          <el-input v-model="remark"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="onAdd">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="忽略用户ID" :visible.sync="dialogUserVisible">
      <el-form>
        <el-form-item label="忽略用户（多个用户ID请用英文逗号,分割开）">
          <el-input v-model="exceptBlackList" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogUserVisible = false">取 消</el-button>
        <el-button type="primary" @click="onExcept">确 定</el-button>
      </div>
    </el-dialog>
    <!-- phone拉黑列表展示 -->
    <el-table
      stripe
      ref="table"
      v-loading="loadingData"
      :data="tableData"
      :max-height="tableHeight"
      border
      style="width: 100%"
    >
      <el-table-column prop="id" label="ID" width="150"> </el-table-column>
      <el-table-column prop="created_at" label="拉黑日期"> </el-table-column>
      <el-table-column prop="gdid" label="设备号"> </el-table-column>
      <el-table-column prop="admin.name" label="操作人员"> </el-table-column>
      <el-table-column prop="remark" label="备注"> </el-table-column>
      <el-table-column prop="except_user_ids" label="忽略用户ID"> </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button type="danger" plain @click="del_blackGdid(scope.row.id)"
            >删除</el-button
          >
          <el-button type="warning" plain @click="() => {
            currentId = scope.row.id
            exceptBlackList = scope.row.except_user_ids
            dialogUserVisible = true
          }"
            >忽略用户</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalRecords"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import fetch from "@/assets/js/axios.js";
import { urlSplicing } from "@/assets/js/public.js";
export default {
  name: "users",
  components: {},
  data() {
    return {
      // 添加黑名单
      addBlackList: '',
      dialogFormVisible: false,
      loadingData: false,
      searchValue: {
        gdid: "",
      },
      historyValue: "",
      tableHeight: 0,
      tableData: [],
      totalRecords: 0,
      currentPage: 1,
      pageSize: 10,
      remark: '',
      dialogUserVisible: false,
      exceptBlackList: '',
    };
  },
  computed: {
    ...mapState(["host"]),
  },
  created() {
    this.getBlackGdidList(true);
  },
  updated() {
    this.$nextTick(() => {
      this.$refs["table"].doLayout();
    });
  },
  beforeMount(height) {
    var h = document.documentElement.clientHeight;
    this.tableHeight = h - 60; //减去页面上固定高度height
  },
  methods: {
    // 导出
    onExport() {
      let params = {
        ...this.historyValue, // 传对应的搜索的值
        export: 1,
        token: sessionStorage.getItem("access_token"),
      };

      urlSplicing(this.host + "admin/black_gdids/list", params);
    },
    // 编辑
    onExcept () {
      fetch({
        url: '/admin/black_gdids/edit',
        method: 'GET',
        params: {
          id: this.currentId,
          except_user_ids: this.exceptBlackList,
        },
      }).then(res => {
        if (res.data.status) {
          this.$message.success('操作成功')
          this.dialogUserVisible = false
          this.exceptBlackList = ''
          this.getBlackGdidList()
        } else {
          this.$message.error(res.data.message)
        }
      })
    },
    // 添加
    onAdd () {
      fetch({
        url: '/admin/black_gdids/create',
        method: 'GET',
        params: {
          gdid: this.addBlackList,
          remark: this.remark,
        },
      }).then(res => {
        if (res.data.status) {
          this.$message.success('添加成功')
          this.dialogFormVisible = false
          this.remark = ''
          this.addBlackList = ''
          this.getBlackGdidList()
        } else {
          this.$message.error(res.data.message)
        }
      })
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getBlackGdidList(false);
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getBlackGdidList(false);
    },
    // 实现游戏数据搜索
    searchUsersList() {
      this.currentPage = 1;
      this.getBlackGdidList(true);
    },
    // 删除
    del_blackGdid(id) {
      this.$confirm("是否确定删除该数据?", "操作确认", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.del_blackGdidSubmit(id);
        })
        .catch(() => {});
    },
    del_blackGdidSubmit(id) {
      fetch({
        url: "/admin/black_gdids/delete",
        method: "GET",
        params: {
          id: id,
        },
      }).then((res) => {
        if (res.data.status) {
          this.$message({
            type: "success",
            message: "删除成功！",
          });
          this.getBlackGdidList();
        } else {
          this.$message.error(res.data.message);
        }
      });
    },

    // 展示设备号拉黑列表数据
    getBlackGdidList(reload = false) {
      let searchValue = {};
      if (reload) {
        this.historyValue = JSON.parse(JSON.stringify(this.searchValue));
        searchValue = this.searchValue;
      } else {
        searchValue = this.historyValue;
      }
      this.loadingData = true;
      fetch({
        url: "/admin/black_gdids/list",
        method: "GET",
        params: {
          ...searchValue,
          page: this.currentPage,
          per_page: this.pageSize,
        },
      })
        .then((res) => {
          if (res.data.status) {
            this.tableData = res.data.data.data;
            this.totalRecords = res.data.data.total;
          }
        })
        .finally(() => {
          this.loadingData = false;
        });
    },
  },
};
</script>
<style lang="less">
a {
  text-decoration: none;
  color: #606266;
}
.pagination {
  text-align: right;
  margin-top: 20px;
  padding-bottom: 20px;
}
.list-hd {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 20px;
  .el-input-group {
    width: 370px;
  }
}
</style>
